import React, { useEffect, useMemo, useState } from "react";
import Sort from "../assets/Arrow-down.svg";
import { AppDispatch, RootState } from "../../../redux-store/store";
import { useDispatch, useSelector } from "react-redux";
import { IUser, UserControlSlices } from "../../../slices/UserControlSlice";

import PasswordGenerator from "./PasswordGenerator";
import { Tooltip, Pagination } from "antd";
import {
  MaterialReactTable,
  MRT_ColumnDef,
  useMaterialReactTable,
} from "material-react-table";
import {
  GetAllUser,
  Lock_UnlockAccount,
} from "../../../api/ssoapi/UserControlapi";
import UserFilter, { userDBTilte } from "./UserFilterPopup";
import { SearchFilterSort } from "../../searchFilter/SearchFilterSort.Component";
import TableAction from "./TableAction";

const UserContorlTable: React.FC = () => {
  const {
    userControlTable: users,
    api: getUserApi,
    enablePasswordGenerator,
  } = useSelector((state: RootState) => state.userControl);
  const user = useSelector((state: RootState) => state.user.user);

  const { searchFilter } = useSelector((state: RootState) => state.userControl);

  const [userData, setUserData] = useState<IUser[]>([]);

  const dispatch = useDispatch<AppDispatch>();

  const handleSorting = (field: string) => {
    let fieldName = "";
    let newIsAscending = false;

    if (searchFilter.apiQuery.sortField?.length > 0) {
      if (searchFilter.apiQuery.sortField === field) {
        if (searchFilter.apiQuery.isAscending === false) {
          fieldName = "";
          newIsAscending = false;
        } else {
          fieldName = searchFilter.apiQuery.sortField;
          newIsAscending = false;
        }
      } else {
        fieldName = field;
        newIsAscending = true;
      }
    } else {
      fieldName = field;
      newIsAscending = true;
    }

    dispatch(
      UserControlSlices.UpdateSorting({
        isAscending: newIsAscending,
        sortField: fieldName,
      })
    );
  };

  //useEffect hook calling for setUser action
  useEffect(() => {
    setUserData(users);
  }, [users]);

  // define the cloumns actions
  const columns = useMemo<MRT_ColumnDef<IUser>[]>(
    () => [
      {
        accessorKey: "userName",
        header: "",
        Header: () => (
          <div className="user-table-head-div">
            <div>
              <span style={{ marginRight: "5px" }}>UserName</span>
              <SearchFilterSort
                fieldName={userDBTilte.userName}
                currentSortFieldName={searchFilter.apiQuery.sortField}
                isAscending={searchFilter.apiQuery.isAscending}
                onClick={handleSorting}
              />
            </div>
            <UserFilter
              searchField="UserName"
              accessorKey="userName"
              isFilter={searchFilter.tempColumnSearch.userName.isFiltered}
            />
          </div>
        ),
        size: 100,
        Cell: ({ cell }) => (
          <span className="table-row-content">{cell.getValue<string>()}</span>
        ),
      },
      {
        accessorKey: "email",
        header: "",
        Header: ({ column }) => (
          <div className="user-table-head-div">
            <div>
              <span style={{ marginRight: "5px" }}>Email ID</span>
              <SearchFilterSort
                fieldName={userDBTilte.email}
                currentSortFieldName={searchFilter.apiQuery.sortField}
                isAscending={searchFilter.apiQuery.isAscending}
                onClick={handleSorting}
              />
            </div>
            <UserFilter
              searchField="Email"
              accessorKey="email"
              isFilter={searchFilter.tempColumnSearch.email.isFiltered}
            />
          </div>
        ),
        size: 120,
        Cell: ({ cell }) => (
          <Tooltip title={cell.getValue<string>()}>
            <span className="table-row-content">
              {cell.getValue<string>().slice(0, 12)}...
            </span>
          </Tooltip>
        ),
      },
      {
        accessorKey: "roles",
        header: "",
        Header: () => (
          <div className="user-table-head-div">
            <div>
              <span style={{ marginRight: "5px" }}>Access Applications</span>
              <SearchFilterSort
                fieldName={userDBTilte.accessApplications}
                currentSortFieldName={searchFilter.apiQuery.sortField}
                isAscending={searchFilter.apiQuery.isAscending}
                onClick={handleSorting}
              />
            </div>
            <UserFilter
              searchField="Access Applications"
              accessorKey="accessApplications"
              isFilter={searchFilter.tempColumnSearch.accessApplications.isFiltered}
            />
          </div>
        ),
        size: 98,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue<string>().toString();

          if (!cellValue) {
            return <span>-</span>;
          }
          const items = cellValue.split(",");
          return (
            <>
              {items.length === 0 ? (
                <span>-</span>
              ) : (
                items.map((item, index) => (
                  <span key={index} className="acess-element">
                    {item}
                  </span>
                ))
              )}
            </>
          );
        },
      },
      {
        accessorKey: "ssoRoles",
        header: "",
        Header: () => (
          <div className="user-table-head-div">
            <div>
              <span style={{ marginRight: "5px" }}>SSO Roles</span>
              <SearchFilterSort
                fieldName={userDBTilte.ssoRoles}
                currentSortFieldName={searchFilter.apiQuery.sortField}
                isAscending={searchFilter.apiQuery.isAscending}
                onClick={handleSorting}
              />
            </div>
            <UserFilter
              isFilter={searchFilter.tempColumnSearch.ssoRoles.isFiltered}
              searchField="SSORoles"
              accessorKey="ssoRoles"
            />
          </div>
        ),
        size: 80,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue<string>()?.toString() || "";

          if (!cellValue) {
            return <span>-</span>;
          }

          const items = cellValue.split(",");
          return (
            <div className="sso-roles-list">
              {items.length === 0 ? (
                <span>-</span>
              ) : (
                <ul className="user-sso-list">
                  {items.map((item, index) => (
                    <li key={index} className="roles-li">
                      {item.trim()}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          );
        },
      },
      {
        accessorKey: "isOtpEnabled",
        header: "",
        Header: () => (
          <div className="user-table-head-div">
            <div>
              <span style={{ marginRight: "5px" }}>OTP</span>
              <SearchFilterSort
                fieldName={userDBTilte.otp}
                currentSortFieldName={searchFilter.apiQuery.sortField}
                isAscending={searchFilter.apiQuery.isAscending}
                onClick={handleSorting}
              />
            </div>
            <UserFilter
              searchField="OTP"
              accessorKey="otp"
              isFilter={searchFilter.tempColumnSearch.otp.isFiltered}
            />
          </div>
        ),
        size: 80,
        Cell: ({ cell }) => {
          const otp = cell.getValue<string>();
          return (
            <>
              {otp ? (
                <span
                  className="table-row-content"
                  style={{ color: "#068244" }}
                >
                  Enabled
                </span>
              ) : (
                <span
                  className="table-row-content"
                  style={{ color: "#AD0303" }}
                >
                  Disabled
                </span>
              )}
            </>
          );
        },
      },
      {
        accessorKey: "account",
        header: "",
        Header: () => (
          <div className="user-table-head-div">
            <div>
              <span style={{ marginRight: "5px" }}>Account Status</span>
              <SearchFilterSort
                fieldName={userDBTilte.accountStatus}
                currentSortFieldName={searchFilter.apiQuery.sortField}
                isAscending={searchFilter.apiQuery.isAscending}
                onClick={handleSorting}
              />
            </div>
            <UserFilter
              searchField="Account Status"
              accessorKey="accountStatus"
              isFilter={searchFilter.tempColumnSearch.accountStatus.isFiltered}
            />
          </div>
        ),
        size: 120,
        Cell: ({ cell }) => {
          const status = cell.getValue<string>();
          let statusvalue = status === "LOCK" ? "Locked" : "Active";
          return <span className="table-row-content">{statusvalue}</span>;
        },
      },
      {
        accessorKey: "ccEmailIds",
        header: "",
        size: 95,
        Header: () => (
          <div className="user-table-head-div">
            <div>
              <span style={{ marginRight: "5px" }}>CC Email Ids</span>
              <SearchFilterSort
                fieldName={userDBTilte.ccEmailIds}
                currentSortFieldName={searchFilter.apiQuery.sortField}
                isAscending={searchFilter.apiQuery.isAscending}
                onClick={handleSorting}
              />
            </div>
            <UserFilter
              searchField="CC Email Ids"
              accessorKey="ccEmailIds"
              isFilter={searchFilter.tempColumnSearch.ccEmailIds.isFiltered}
            />
          </div>
        ),
        Cell: ({ cell }) => {
          let ccEmails = "-";

          if (cell && cell?.getValue<string>() && cell.getValue()?.toString()) {
            ccEmails = cell.getValue<string>().toString();
          } else {
            return <span>-</span>;
          }

          return (
            <Tooltip title={ccEmails}>
              <span key={0} className="table-row-content">
                {ccEmails.slice(0, 15)}...
              </span>
            </Tooltip>
          );
        },
      },
    ],
    [handleSorting]
  );

  // set table necessary option and data
  const table = useMaterialReactTable({
    columns: columns,
    data: userData,
    enableColumnActions: false,
    enableSorting: false,
    enableColumnFilterModes: false,
    enableFilters: false,
    enableFullScreenToggle: false,
    enableGlobalFilter: false,
    enableDensityToggle: false,
    enableHiding: false,
    enableRowActions: true,
    enablePagination: false,
    enableTableFooter: false,
    enableStickyHeader: true,
    initialState: {
      density: "compact",
    },
    state: { isLoading: getUserApi.isLoading },
    positionActionsColumn: "last",
    renderRowActions: ({ row }) => <TableAction row={row.original} />,
    muiTableBodyCellProps: {
      sx: {
        textAlign: "left",
        height: "47px",
      },
    },
    muiTableHeadCellProps: {
      sx: {
        backgroundColor: "#F8F8F8",
        color: "#8e8e8e",
        textAlign: "left",
        fontFamily: "Inter",
        fontWeight: "bold",
        fontSize: "13px",
        paddingTop: "20px",
        height: "42px",
        position: "sticky",
      },
    },
    muiTablePaperProps: {
      sx: {
        boxShadow: "none",
        border: "1px solid #D9D9D9",
        borderRadius: "5px",
        height: "calc(100% - 5px)",
        overflowY: "auto",
      },
    },
  });
  return (
    <>
      <MaterialReactTable table={table} />
      {enablePasswordGenerator ? <PasswordGenerator /> : ""}
    </>
  );
};

export default UserContorlTable;
